import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../firebase/auth";
import PageMenu from "./pageMenu.tsx";

// Define the props interface
interface ProtectedRouteProps {
  children: React.ReactNode;
  fullScreenMode?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  fullScreenMode,
}) => {
  const {
    userId,
    userRole,
    firstName,
    lastName,
    user,
    headquarterId,
    groupId,
    logout,
  } = useAuth();

  if (!userRole) {
    return <Navigate to="/login" />;
  }

  return (
    <>
      <PageMenu
        userRole={userRole}
        userId={userId}
        firstName={firstName}
        lastName={lastName}
        groupId={groupId}
        headquarterId={headquarterId}
        email={user}
        logout={logout}
        fullScreenMode={fullScreenMode}
      />
      {children}
    </>
  );
};

export { ProtectedRoute };
